<div [class]="theme()">
  <p-iconfield
    [styleClass]="size()"
    [ngStyle]="{
      '--right-icon-size': rightIconConfig()?.size ? rightIconConfig()!.size + 'px' : '20px',
      '--left-icon-size': leftIconConfig()?.size ? leftIconConfig()!.size + 'px' : '20px',
    }">
    @if (leftIconConfig(); as leftIcon) {
      <sxw-input-icon [icon]="leftIcon" class="left" />
    }
    <p-inputNumber
      #numberInput
      inputId="horizontal"
      decrementButtonClass="p-button-danger"
      incrementButtonClass="p-button-success"
      incrementButtonIcon="pi pi-plus"
      decrementButtonIcon="pi pi-minus"
      [maxFractionDigits]="maxFractionDigits()"
      [placeholder]="placeholder() | translate"
      [showButtons]="enableShowButtons()"
      [buttonLayout]="enableButtonLayout()"
      [locale]="localType()"
      [mode]="modeType()"
      [step]="stepValue()"
      [min]="minValue()"
      [max]="maxValue()"
      [currency]="currencyType()"
      [currencyDisplay]="currencyDisplay()"
      [useGrouping]="useGrouping()"
      [(ngModel)]="value"
      (onBlur)="onBlur($event)"
      (onInput)="onInputChanged($event)"
      (onKeyDown)="onKeyDown($event)"
      [disabled]="disabled"
      [readonly]="readonly"
      fluid
      [dt]="dt()"
      [size]="size()"
      [inputStyleClass]="isInvalidControl ? 'invalid-input' : ''"
      [suffix]="suffix() | translate"
      [prefix]="prefix() | translate"
      [minFractionDigits]="minFractionDigits()"
      class="full-width-input"
      [maxlength]="maxLength()"></p-inputNumber>

    @if (rightIconConfig(); as rightIcon) {
      <sxw-input-icon [icon]="rightIcon" class="right" />
    }
    @if (isInvalidControl) {
      <sxw-input-icon
        class="right"
        [icon]="{ size: rightIconConfig()?.size, name: 'exclamation-mark', fillColor: 'var(--p-red-500)', strokeColor: 'var(--p-red-500)' }" />
    }
  </p-iconfield>

  @if (isInvalidControl) {
    <sxw-error-message [message]="control ? control.errors : null"></sxw-error-message>
  }
</div>
